import React from 'react';
import AmountConverter from '../../common/amountConverter'
import DateFormat from '../../common/dateFormat'


const CreditCard = (props) => {
    const {credit, onButtonClick} = props;
    
    return(
        <div onClick={onButtonClick} className="credits-item-wrap cursor-pointer">
            <div className="credits-item-inner">
                <div className="credits-item-top relative mb-2">
                    <div className="credits-item-img">                                
                        <img loading="lazy" src={credit?.store_credit_image} alt="" className="rounded-lg w-full" />
                    </div>
                    <div className="credits-item-logo absolute bottom-2 left-2 credit-logo">
                        <img loading="lazy" src={credit?.logo} alt="" />
                    </div>
                    <div className="credits-item-price py-1 px-2 rounded-md bg-[#FFE940] text-base font-Rany font-bold inline-block absolute top-2 right-2">
                        <AmountConverter amount={credit?.total_credit_amount} />
                    </div>
                </div>
                <div className="credits-item-bottom">
                    <div className="credits-item-title text-2xl text-[#0F0F0F] font-Rany font-bold">
                        {credit.store_name}
                    </div>
                    <div className="credits-item-desc text-base text-[#495057]">
                        <span className="font-Rany">Earliest expiry:</span> <span className="">
                            <DateFormat date={credit?.earliest_expiry} outputFormat={'DD MMMM YYYY'} />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreditCard;
